import React from 'react';
export function Footer() {
  return <footer className="bg-brand-night px-4 pb-28 pt-12 text-center text-sm text-white/70 md:pb-12" data-id="element-82" data-mp="32wd2qgad7ltj">
      <div className="mx-auto max-w-4xl" data-id="element-83" data-mp="3ggk7gsifd7yh">
        <div className="mb-3 font-display text-xl font-bold text-white" data-id="element-84" data-mp="32o4d0g3lai96">🌍 GEOGRAFIA PRONTA</div>
        <p className="mx-auto max-w-md text-xs leading-relaxed text-white/60" data-id="element-85" data-mp="36p6d0z5byyc7">
          Il percorso completo di Geografia, pronto da stampare, per la Scuola Primaria e Secondaria di Primo Grado
          italiana.
        </p>
        <nav aria-label="Note legali" className="mb-8 mt-8 flex flex-wrap items-center justify-center gap-6" data-id="element-86" data-mp="37o5ytxdtvcu">
          <a href="#termini" className="transition-colors duration-150 ease-out hover:text-white" data-id="element-87" data-mp="3ldkcd03jg4o0">
            Termini e Condizioni
          </a>
          <a href="#privacy" className="transition-colors duration-150 ease-out hover:text-white" data-id="element-88" data-mp="29z6tk9nn6feu">
            Privacy
          </a>
          <a href="#contatti" className="transition-colors duration-150 ease-out hover:text-white" data-id="element-89" data-mp="2eyjq5m4bf0um">
            Contatti
          </a>
        </nav>
        <p data-id="element-90" data-mp="3lbmtfq7jj4eu">© 2026 GEOGRAFIA PRONTA™ — Tutti i diritti riservati.</p>
      </div>
    </footer>;
}